import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import InviteModal from './InviteModal'
import ContactUsModal from './ContactUsModal'

export default class ContactInviteCombo extends Component {
	state = {
		displayInviteModal: false,
		displayContactUsModal: false
	}

	dismissInviteModal = () => {
		this.setState({displayInviteModal: false})
	}

	displayInviteModal = (e) => {
		e.preventDefault()
		window.mixpanel.track('[AdScore] - No Access Modal Shown')
		this.setState({displayInviteModal: true})
	}

	dismissContactUsModal = () => {
		this.setState({displayContactUsModal: false})
	}

	contactUsLinkClicked = (e) => {
		e.preventDefault()
		window.mixpanel.track('[AdScore] - Contact Us Modal Shown')
		this.setState({
			displayInviteModal: false,
			displayContactUsModal: true
		})
	}

	render() {
		return (
			<Fragment>
				{this.props.children}
				<div className="info-box">
					<p>Don’t have access to your ad accounts?<br />Reach out to a co-worker who can help.</p>
					<button className="account-invite" onClick={this.displayInviteModal}>Reach Out</button>
				</div>
				<InviteModal
					display={this.state.displayInviteModal}
					modalDismissed={this.dismissInviteModal}
					sessionEmail={this.props.sessionEmail}
					contactLinkClicked={this.contactUsLinkClicked} />
				<ContactUsModal
					display={this.state.displayContactUsModal}
					modalDismissed={this.dismissContactUsModal}
					sessionEmail={this.props.sessionEmail} />
			</Fragment>
		)
	}
}

ContactInviteCombo.propTypes = {
	children: PropTypes.element.isRequired,
	sessionEmail: PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/components/ContactInviteCombo.js